export default __webpack_public_path__ + "8ae5ac0f43beb4204e3eb13e91223220.svg";